export default {
  SET_TOTAL_NOT_CORRECTED( state, { totalNotCorrected, isDetailsModalOpen }) {
    if (isDetailsModalOpen) {
      state.totalNotCorrectedDetailsModal = totalNotCorrected;
      return;
    }
    state.totalNotCorrected = totalNotCorrected;
  },
  SET_TOTAL_NEW_MESSAGES(state, { totalNewMessages, isDetailsModalOpen }) {
    if (isDetailsModalOpen) {
      state.totalNewMessagesDetailsModal = totalNewMessages;
      return;
    }
    state.totalNewMessages = totalNewMessages;
  },
  SET_TOTAL_SATISFACTORY_PROGRESS(state, { totalSatisfactoryProgress, isDetailsModalOpen }) {
    if (isDetailsModalOpen) {
      state.totalSatisfactoryProgressDetailsModal = totalSatisfactoryProgress;
      return;
    }
    state.totalSatisfactoryProgress = totalSatisfactoryProgress;
  }
};
